import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Injectable } from "@angular/core";
import { IMarkupService, CHANNEL_MARKUP } from "../IMarkupService";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import { MarkupCriteria } from "../../model/core/MarkupCriteria";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class MarkupReplicaService implements IMarkupService {
  protected broker: ClientMessageBroker;

  constructor(protected factory: ClientMessageBrokerFactory) {
    // this.VALUE = CubiqTS.ENCODABLE(CubiqTS.MarkupInfoImpl);
    this.broker = this.factory.createMessageBroker(CHANNEL_MARKUP, true, true);
  }

  public retrieveMarkupForCriteria(
    criteria: MarkupCriteria,
  ): Promise<CubiqTS.MarkupInfoImpl | CubiqTS.ErrorsImpl> {
    let request = new UiArguments("retrieveMarkupForCriteria");
    let arg1 = new FnArg(criteria, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, CubiqTS.ENCODABLE(CubiqTS.MarkupInfoImpl));
  }
}
